import React, { useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { MathUtils } from 'three';
import { RootState } from '../../../types/data';
import { getExperience, resetExperience } from '../../../store/actions/experience';
import { navigateSpace } from '../../../store/actions/app';
import { useMedia } from '../../../hooks';
import { MediaEvents, MediaType } from '../../../common/media';
import { SlideshowSpaceResourceId } from '../../../common/constants/xr';
import { EXPERIENCE_ENDED } from '../../../common/constants/gateway-events';
import GatewayService from '../../../services/gateway-service';
import Player from '../../../components/xr/player';
import BookingWindow from '../booking';
import PreloadService from '../../../services/preload-service';

const { degToRad } = MathUtils;

type ExperiencePhotoSpaceProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<{ experienceId?: string }> & {
    data: any[];
  };

const ExperiencePhotoSpace = ({ experience, data, navigateSpace }: ExperiencePhotoSpaceProps) => {
  const media = useMedia(SlideshowSpaceResourceId, MediaType.Slideshow);
  const location = useLocation();
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });

  const showPlayer = Number(params.playerMode) !== 2;
  const showBookingWindow = showPlayer && Number(params.playerMode) !== 1;

  useEffect(() => {
    if (media) {
      const changeSpace = (index: number) => {
        const point = data[index];

        navigateSpace(point);
      };

      media.on(MediaEvents.Timeupdate, ({ currentTime, duration }) => {
        const index = currentTime === 0 ? 0 : currentTime - 1;

        changeSpace(index);
      });

      media.on(MediaEvents.Ended, () =>
        GatewayService.emit(EXPERIENCE_ENDED, {
          type: 'experience_tour',
        })
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media]);

  useEffect(() => {
    if (media) {
      media.setResource({
        //@ts-ignore
        src: data.length,
      });
      setTimeout(() => {
        const pointIds = data.map((point: any) => point.id);
        PreloadService.loadNextPointsData(pointIds);
      }, 2000);
    }
  }, [media, data]);

  return (
    <group>
      <group position={[0, 0, 0]}>
        <group position={[0, -0.5, -1]} scale={[1.5, 1.5, 1.5]} rotation={[degToRad(-15), 0, 0]}>
          {showBookingWindow ? <BookingWindow data={experience.data} position={[0, 0.1, 0]} /> : null}
          {showPlayer ? <Player position={[0, 0, 0]} target={SlideshowSpaceResourceId} mode="slideshow" /> : null}
        </group>
      </group>
    </group>
  );
};

const mapStateToProps = (state: RootState) => ({
  experience: state.experience?.current,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getExperience,
      resetExperience,
      navigateSpace,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExperiencePhotoSpace));
